import React from 'react';
import { WarningCallOut } from '@grnhse/seedling/lib/birch/components/call_out';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';

const t = withLocalePrefix('candidate_search.email_modal.domain_warning');

type Props = {
  domain: string;
};

const BodyWithBold = styled(Body)`
  .unverified_email_domain {
    font-weight: 500;
  }
`;

const UnverifiedDomainCallout = ({ domain }: Props) => {
  if (!domain) {
    return null;
  }

  return (
    <WarningCallOut
      headerText={t('title')}
      bodyText={
        <Stack>
          <BodyWithBold
            dangerouslySetInnerHTML={{ __html: t('body', { domain: domain }) }}
          />
        </Stack>
      }
      linkProps={{
        href: t('url'),
        target: '_blank',
        children: t('visit'),
      }}
    />
  );
};

export default UnverifiedDomainCallout;
